import { ArrowBack } from '@mui/icons-material';
import { Box } from '@mui/material';

import { Button, ButtonVariants } from '@/components';
import {
  onboardingThunks,
  selectIsHandlingStepTransition,
  selectOnboardingActiveStepInput,
  stepsConfig,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { useOnboardingSteps } from '../useOnboardingSteps';

export const Footer = () => {
  const dispatch = useAppDispatch();

  const isHandlingStepTransition = useAppSelector(
    selectIsHandlingStepTransition,
  );
  const activeStepInput = useAppSelector(selectOnboardingActiveStepInput);

  const { steps, activeStep, activeStepIndex } = useOnboardingSteps();

  const activeStepConfig = stepsConfig[activeStep];
  const isPrevButtonDisabled = isHandlingStepTransition;
  const isNextButtonDisabled =
    // some steps allow attempted submission with invalid input
    // before displaying validation errors
    !(
      activeStepConfig.isSubmitAllowed?.(activeStepInput) ??
      activeStepConfig.isStepInputValid(activeStepInput)
    ) || isHandlingStepTransition;

  const handlePrev = () => {
    dispatch(onboardingThunks.goToPrevStep());
  };

  const handleNext = () => {
    dispatch(onboardingThunks.goToNextStep());
  };

  const canUserGoBack = activeStepIndex > 0;
  const nextButtonCopy =
    activeStepIndex === steps.length - 1 ? 'Explore LumiQ' : 'Next';

  return (
    <Box
      sx={{
        width: '100%',
        pt: 1,
        zIndex: 1,
        backgroundColor: 'surface.background',
      }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1.5,
        }}>
        <Box>
          {canUserGoBack && (
            <Button
              variant={ButtonVariants.TERTIARY}
              onClick={handlePrev}
              disabled={isPrevButtonDisabled}
              label="Back"
              skinny={false}
              fullWidth={false}
              startIcon={<ArrowBack />}
              sx={{ float: 'left' }}
            />
          )}
        </Box>
        <Box>
          {handleNext && (
            <Button
              onClick={handleNext}
              disabled={isNextButtonDisabled}
              label={nextButtonCopy}
              fullWidth={false}
              skinny={false}
              sx={{ float: 'right' }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
